import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      padding-top: ",
        ";\n      padding-bottom: ",
        ";\n      ",
        " {\n        padding-top: ",
        ";\n        padding-bottom: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n        width: 100%;\n        object-fit: cover;\n        object-position: right;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Styles, Theme } from "@silvertours/front-shared";
var SegmentContainer = /*#__PURE__*/ styled("section", {
    target: "eohdt8x0"
})("display:block;position:relative;color:", Theme.Color.secondary100, ";background-color:", function(param) {
    var theme = param.theme, fillColor = param.fillColor;
    return fillColor ? theme.color[fillColor] : "transparent";
}, ";", function(param) {
    var _needLayoutContentPadding = param.needLayoutContentPadding, needLayoutContentPadding = _needLayoutContentPadding === void 0 ? true : _needLayoutContentPadding;
    return needLayoutContentPadding && Styles.Global.layoutContentOnlyPadding;
}, ";", function(param) {
    var hasPadding = param.hasPadding, spacingScale = param.spacingScale;
    return hasPadding && css(_templateObject(), "".concat(spacingScale * 0.75, "rem"), "".concat(spacingScale * 0.75, "rem"), Theme.mq("xl"), "".concat(spacingScale * 1.25, "rem"), "".concat(spacingScale * 1.25, "rem"));
}, ";");
var HeaderContainer = SegmentContainer.withComponent("header");
var NavigationContainer = SegmentContainer.withComponent("nav");
var SegmentImageContainer = /*#__PURE__*/ styled("div", {
    target: "eohdt8x1"
})("overflow:hidden;position:absolute;top:0;left:0;z-index:0;width:100%;display:block;img{/* Stage image usally has important details on right side,make them visible in any resolution */\n    ", function(param) {
    var isStage = param.isStage, includeSearch = param.includeSearch;
    return isStage && includeSearch && css(_templateObject1());
}, "}", function(param) {
    var isStage = param.isStage, includeSearch = param.includeSearch;
    return isStage && !includeSearch && "position: relative;\n    aspect-ratio: 1.66/1;\n    ".concat(Theme.mq("md"), " {\n      aspect-ratio: 2/1;\n    }\n    ").concat(Theme.mq("lg"), " {\n      position: absolute;\n      aspect-ratio: unset;\n    }\n    ");
}, " ", Theme.mq("lg"), "{height:100%;}");
var SegmentForegroundContainer = /*#__PURE__*/ styled("div", {
    target: "eohdt8x2"
})("left:0;width:100%;", Theme.mq("lg"), "{position:relative;margin:0 auto;}");
export { HeaderContainer, NavigationContainer, SegmentContainer, SegmentForegroundContainer, SegmentImageContainer };
